
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_136ic_98",
  "button": "awsui_button_vjswe_136ic_102",
  "variant-normal": "awsui_variant-normal_vjswe_136ic_125",
  "is-activated": "awsui_is-activated_vjswe_136ic_138",
  "variant-icon": "awsui_variant-icon_vjswe_136ic_165",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_136ic_165",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_136ic_165",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_136ic_183",
  "disabled": "awsui_disabled_vjswe_136ic_201",
  "variant-primary": "awsui_variant-primary_vjswe_136ic_209",
  "variant-link": "awsui_variant-link_vjswe_136ic_293",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_136ic_713",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_136ic_800",
  "button-no-text": "awsui_button-no-text_vjswe_136ic_884",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_136ic_888",
  "icon-left": "awsui_icon-left_vjswe_136ic_904",
  "icon-right": "awsui_icon-right_vjswe_136ic_909",
  "icon": "awsui_icon_vjswe_136ic_904"
};
  